import React from 'react'

const Manual_menu_categoria = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          MENÚ - Categoría
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo crear o editar categorías en un sistema de ventas para gestionar el inventario de forma eficiente. Permite organizar los ítems, mejorar su visibilidad y optimizar el proceso de ventas.
        </p>
        <iframe
          src="https://scribehow.com/embed/MENU__Categoria__EAf4j2Z3RrqA6jFgVuQL-A?as=scrollable"
          className="scribe-iframe-general-15"
          width="100%"
          height="2900"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_menu_categoria